<template>
    <div
        class="d-flex flex-column flex-sm-row align-items-center justify-content-between p-0 ps-3 pe-2 pb-3 pb-sm-0 w-100"
        :class="showBorder ? 'dashboard-border-left' : ''"
        id="DashboardHeader"
    >
        <div class="dashboard-header-section order-1">
            <p class="welcome-title fw-bold m-0">
                Welcome <span class="text-capitalize">{{ userName }}</span>
            </p>
        </div>
        <div
            class="dashboard-header-middle-section d-flex flex-row justify-content-between justify-content-sm-center my-md-2 order-3 order-sm-2"
        >
            <div v-if="hasPlannertaskList" class="dashboard-weather-vue">
                <WeatherReport />
            </div>
            <div v-if="hasPlannertaskList" class="divider"></div>
            <div class="dashboard-date-vue">
                <DateTime />
            </div>
        </div>

        <div
            class="dashboard-header-section d-flex flex-wrap gap-4 gap-md-0 justify-content-between justify-content-md-end p-0 order-2 order-sm-3 my-4 my-md-0"
        >
            <!-- <a class="dashboard-menu">
                <span class="text-center">Search</span>
                <i class="fas fa-search icon"></i>
            </a> -->
            <a class="dashboard-menu-vue" @click="goToHelp()">
                <span class="text-center">Help</span>
                <i class="fas fa-question-circle icon"></i>
            </a>
            <a class="dashboard-menu-vue" @click="logout()">
                <span class="text-center">Logout</span>
                <i class="fas fa-sign-out-alt icon"></i>
            </a>
        </div>
    </div>
</template>

<script lang="ts" src="./DashboardHeader.ts"></script>
<style src="./DashboardHeader.scss"></style>
